import { render, staticRenderFns } from "./hzletterapproval.vue?vue&type=template&id=c24fe964&scoped=true&"
import script from "./hzletterapproval.vue?vue&type=script&lang=ts&"
export * from "./hzletterapproval.vue?vue&type=script&lang=ts&"
import style0 from "./hzletterapproval.vue?vue&type=style&index=0&id=c24fe964&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24fe964",
  null
  
)

export default component.exports